export interface VideoItem {
  id: string;
  title: string;
  thumbnail: string;
  duration: string;
  views: string;
  category: string;
  categorySlug: string;
  author: string;
  authorAvatar: string;
  date: string;
  description: string;
  tags: string[];
}

export interface CategoryItem {
  name: string;
  slug: string;
  icon: string;
  count: number;
  color: string;
}

export interface CreatorItem {
  name: string;
  avatar: string;
  followers: string;
  videos: number;
  description: string;
}

export const categories: CategoryItem[] = [
  { name: '娱乐', slug: 'entertainment', icon: 'ri-movie-line', count: 12580, color: 'primary' },
  { name: '搞笑', slug: 'funny', icon: 'ri-emotion-laugh-line', count: 9820, color: 'accent' },
  { name: '美食', slug: 'food', icon: 'ri-restaurant-line', count: 6540, color: 'primary' },
  { name: '旅行', slug: 'travel', icon: 'ri-flight-takeoff-line', count: 4320, color: 'accent' },
  { name: '生活', slug: 'lifestyle', icon: 'ri-heart-line', count: 8760, color: 'primary' },
  { name: '音乐', slug: 'music', icon: 'ri-music-line', count: 11230, color: 'accent' },
  { name: '游戏', slug: 'gaming', icon: 'ri-gamepad-line', count: 7890, color: 'primary' },
  { name: '时尚', slug: 'fashion', icon: 'ri-t-shirt-line', count: 5670, color: 'accent' },
];

export const trendingVideos: VideoItem[] = [
  {
    id: 'v001',
    title: '今天带大家看看上海最地道的本帮菜，隐藏在弄堂里的老味道',
    thumbnail: 'https://readdy.ai/api/search-image?query=Delicious%20Shanghai%20local%20cuisine%20in%20a%20traditional%20alley%20restaurant%2C%20warm%20lighting%2C%20steaming%20dishes%20on%20wooden%20table%2C%20cozy%20atmosphere%2C%20food%20photography%20style%2C%20shallow%20depth%20of%20field&width=640&height=360&seq=trending-01&orientation=landscape',
    duration: '05:28',
    views: '128.5万',
    category: '美食',
    categorySlug: 'food',
    author: '吃货小王',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20friendly%20smile%2C%20casual%20style%2C%20clean%20white%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-01&orientation=squarish',
    date: '2026-08-09',
    description: '探索上海弄堂深处的本帮菜老店，品味最地道的红烧肉、油爆虾和糟钵头。这家开了三十年的老店，承载着几代上海人的味觉记忆。',
    tags: ['上海美食', '本帮菜', '老店探店', '弄堂美食'],
  },
  {
    id: 'v002',
    title: '笑死我了！猫咪第一次见到镜子里的自己，这个反应太真实了',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20cute%20orange%20tabby%20cat%20looking%20at%20itself%20in%20a%20mirror%20with%20a%20surprised%20expression%2C%20bright%20living%20room%2C%20natural%20sunlight%2C%20funny%20pet%20moment%2C%20warm%20home%20interior&width=640&height=360&seq=trending-02&orientation=landscape',
    duration: '02:15',
    views: '256.8万',
    category: '搞笑',
    categorySlug: 'funny',
    author: '萌宠日常',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20with%20warm%20smile%2C%20natural%20look%2C%20clean%20white%20background%2C%20professional%20portrait%20photography&width=100&height=100&seq=avatar-02&orientation=squarish',
    date: '2026-08-08',
    description: '家里的橘猫第一次在镜子里看到自己，那表情简直可以做成表情包。从困惑到炸毛，再到慢慢接受，全程高能笑点不断！',
    tags: ['猫咪', '搞笑宠物', '萌宠', '橘猫'],
  },
  {
    id: 'v003',
    title: '一个人的云南之旅：大理古城到洱海环湖，治愈系Vlog',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20Dali%20ancient%20town%20in%20Yunnan%20with%20Erhai%20Lake%20in%20background%2C%20clear%20blue%20sky%2C%20traditional%20Chinese%20architecture%2C%20Cangshan%20mountains%2C%20travel%20photography%20style%2C%20bright%20natural%20lighting&width=640&height=360&seq=trending-03&orientation=landscape',
    duration: '12:36',
    views: '89.3万',
    category: '旅行',
    categorySlug: 'travel',
    author: '旅途小鹿',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20outdoor%20portrait%2C%20travel%20style%2C%20warm%20smile%2C%20clean%20background%2C%20natural%20lighting&width=100&height=100&seq=avatar-03&orientation=squarish',
    date: '2026-08-07',
    description: '一个人背上行囊去大理，从古城漫步到洱海骑行，感受苍山洱海间的慢生活。这一次，我找到了内心的平静。',
    tags: ['云南旅行', '大理', '洱海', '独自旅行', 'Vlog'],
  },
  {
    id: 'v004',
    title: '【翻唱】用最温柔的声音唱《起风了》，听完你会想起谁？',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20young%20person%20singing%20with%20a%20guitar%20in%20a%20cozy%20room%20with%20warm%20fairy%20lights%2C%20soft%20evening%20atmosphere%2C%20intimate%20music%20performance%2C%20warm%20amber%20lighting&width=640&height=360&seq=trending-04&orientation=landscape',
    duration: '04:42',
    views: '198.2万',
    category: '音乐',
    categorySlug: 'music',
    author: '音乐人小林',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20musician%20portrait%2C%20artistic%20style%2C%20warm%20expression%2C%20clean%20background%2C%20soft%20lighting&width=100&height=100&seq=avatar-04&orientation=squarish',
    date: '2026-08-06',
    description: '用最真挚的情感重新演绎这首《起风了》，每一个音符都承载着青春的记忆。希望这首歌能温暖你的夜晚。',
    tags: ['翻唱', '起风了', '吉他弹唱', '治愈音乐'],
  },
  {
    id: 'v005',
    title: '生活小妙招：10个让你相见恨晚的厨房收纳技巧',
    thumbnail: 'https://readdy.ai/api/search-image?query=Organized%20modern%20Chinese%20kitchen%20with%20neat%20storage%20solutions%2C%20clean%20countertops%2C%20warm%20wooden%20accents%2C%20bright%20natural%20light%2C%20minimalist%20interior%20design&width=640&height=360&seq=trending-05&orientation=landscape',
    duration: '06:18',
    views: '156.7万',
    category: '生活',
    categorySlug: 'lifestyle',
    author: '居家达人阿May',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20in%2030s%20portrait%2C%20warm%20and%20friendly%20smile%2C%20home%20style%2C%20clean%20background%2C%20natural%20lighting&width=100&height=100&seq=avatar-05&orientation=squarish',
    date: '2026-08-05',
    description: '厨房总是乱糟糟？教你10个超实用的收纳技巧，让你的厨房焕然一新。从调料瓶到锅碗瓢盆，每一寸空间都不浪费！',
    tags: ['生活妙招', '厨房收纳', '居家技巧', '整理术'],
  },
  {
    id: 'v006',
    title: '当你的队友是职业选手：这操作我看了10遍都不敢相信',
    thumbnail: 'https://readdy.ai/api/search-image?query=Exciting%20video%20game%20gameplay%20moment%20with%20colorful%20effects%2C%20competitive%20gaming%20scene%2C%20dramatic%20lighting%2C%20esports%20style%2C%20dynamic%20action%20shot&width=640&height=360&seq=trending-06&orientation=landscape',
    duration: '03:54',
    views: '312.4万',
    category: '游戏',
    categorySlug: 'gaming',
    author: '游戏达人阿杰',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20gamer%20portrait%2C%20cool%20style%2C%20clean%20background%2C%20professional%20headshot%2C%20warm%20lighting&width=100&height=100&seq=avatar-06&orientation=squarish',
    date: '2026-08-04',
    description: '在排位赛中偶遇职业选手是怎样的体验？这波操作我反复看了十遍，每一帧都是教科书级别的。职业选手的反应速度太离谱了！',
    tags: ['游戏', '电竞', '精彩操作', '高光时刻'],
  },
  {
    id: 'v007',
    title: '2026夏季穿搭指南：显瘦又时髦的7套日常搭配',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stylish%20summer%20fashion%20outfits%20displayed%20on%20a%20minimalist%20rack%2C%20warm%20neutral%20tones%2C%20natural%20lighting%2C%20clean%20aesthetic%2C%20fashion%20flat%20lay%20photography&width=640&height=360&seq=trending-07&orientation=landscape',
    duration: '08:22',
    views: '178.6万',
    category: '时尚',
    categorySlug: 'fashion',
    author: '时装精Lily',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Fashionable%20Chinese%20woman%20portrait%2C%20stylish%20look%2C%20clean%20background%2C%20warm%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-07&orientation=squarish',
    date: '2026-08-03',
    description: '夏天到了还在愁穿什么？给大家整理了7套显瘦又时髦的日常搭配，从通勤到约会全都帮你安排好了，照着穿就对了！',
    tags: ['夏季穿搭', '显瘦搭配', '时尚', '日常穿搭'],
  },
  {
    id: 'v008',
    title: '太搞笑了！街头随机采访：你能用三个字形容你前任吗？',
    thumbnail: 'https://readdy.ai/api/search-image?query=Funny%20street%20interview%20scene%20in%20a%20busy%20Chinese%20city%2C%20people%20laughing%2C%20colorful%20neon%20signs%20in%20background%2C%20warm%20evening%20atmosphere%2C%20candid%20photography%20style&width=640&height=360&seq=trending-08&orientation=landscape',
    duration: '06:45',
    views: '445.8万',
    category: '搞笑',
    categorySlug: 'funny',
    author: '街头笑料',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20content%20creator%20portrait%2C%20fun%20and%20energetic%20expression%2C%20clean%20background%2C%20warm%20lighting&width=100&height=100&seq=avatar-08&orientation=squarish',
    date: '2026-08-02',
    description: '在市中心随机采访路人，让他们用三个字形容前任。答案简直一个比一个精彩，笑到肚子疼！有人说的太扎心，有人说的太真实。',
    tags: ['街头采访', '搞笑', '前任', '随机采访'],
  },
];

export const latestVideos: VideoItem[] = [
  {
    id: 'v009',
    title: '深夜食堂：一个人也要好好吃饭，简单快手番茄牛腩面',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20steaming%20bowl%20of%20beef%20brisket%20noodle%20soup%20with%20tomato%2C%20cozy%20kitchen%20setting%2C%20warm%20lighting%2C%20comfort%20food%20photography%2C%20homemade%20cooking&width=640&height=360&seq=latest-01&orientation=landscape',
    duration: '07:15',
    views: '45.2万',
    category: '美食',
    categorySlug: 'food',
    author: '深夜小食堂',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20food%20blogger%20portrait%2C%20warm%20kitchen%20background%2C%20friendly%20smile%2C%20soft%20lighting&width=100&height=100&seq=avatar-09&orientation=squarish',
    date: '2026-08-10',
    description: '深夜饿了怎么办？教你做一碗简单又美味的番茄牛腩面，食材简单，做法快手，一个人也要好好照顾自己。',
    tags: ['深夜食堂', '番茄牛腩面', '快手菜', '一人食'],
  },
  {
    id: 'v010',
    title: '巴厘岛秘境攻略：99%的游客都不知道的绝美打卡点',
    thumbnail: 'https://readdy.ai/api/search-image?query=Hidden%20beautiful%20waterfall%20in%20Bali%20with%20lush%20tropical%20greenery%2C%20crystal%20clear%20water%2C%20sunlight%20rays%20through%20leaves%2C%20paradise%20travel%20photography&width=640&height=360&seq=latest-02&orientation=landscape',
    duration: '09:48',
    views: '67.8万',
    category: '旅行',
    categorySlug: 'travel',
    author: '环球探险家',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20travel%20blogger%20portrait%2C%20adventurous%20style%2C%20warm%20smile%2C%20outdoor%20look%2C%20clean%20background&width=100&height=100&seq=avatar-10&orientation=squarish',
    date: '2026-08-10',
    description: '去了三次巴厘岛才发现这些隐藏的宝藏地点！远离游客区，这些秘境才是巴厘岛真正的灵魂所在。附详细路线攻略。',
    tags: ['巴厘岛', '秘境', '旅行攻略', '打卡'],
  },
  {
    id: 'v011',
    title: '【原创】用古筝演奏周杰伦《晴天》，这版编曲绝了',
    thumbnail: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20guzheng%20instrument%20being%20played%20by%20elegant%20hands%2C%20soft%20warm%20lighting%2C%20traditional%20room%20setting%2C%20artistic%20music%20performance&width=640&height=360&seq=latest-03&orientation=landscape',
    duration: '04:18',
    views: '234.5万',
    category: '音乐',
    categorySlug: 'music',
    author: '国风音悦台',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20traditional%20musician%20portrait%2C%20elegant%20style%2C%20warm%20expression%2C%20clean%20background%2C%20soft%20lighting&width=100&height=100&seq=avatar-11&orientation=squarish',
    date: '2026-08-10',
    description: '当古筝遇上流行音乐，传统与现代的完美融合。用最中国的声音演绎杰伦的经典，每一个音符都充满了东方韵味。',
    tags: ['古筝', '周杰伦', '晴天', '国风音乐', '原创编曲'],
  },
  {
    id: 'v012',
    title: '上班族的五分钟快速妆容，手残党也能学会的通勤妆',
    thumbnail: 'https://readdy.ai/api/search-image?query=Minimalist%20makeup%20products%20arranged%20neatly%20on%20a%20vanity%20table%2C%20warm%20morning%20sunlight%2C%20clean%20beauty%20aesthetic%2C%20soft%20neutral%20tones&width=640&height=360&seq=latest-04&orientation=landscape',
    duration: '05:32',
    views: '89.1万',
    category: '时尚',
    categorySlug: 'fashion',
    author: '美妆指南针',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20beauty%20blogger%20portrait%2C%20fresh%20makeup%20look%2C%20clean%20background%2C%20warm%20lighting&width=100&height=100&seq=avatar-12&orientation=squarish',
    date: '2026-08-10',
    description: '早起困难户的救星！手把手教你五分钟搞定通勤妆容，简单易学，手残党也能轻松上手。让你美美地去上班！',
    tags: ['通勤妆', '快速化妆', '上班族', '新手化妆'],
  },
  {
    id: 'v013',
    title: '这些生活冷知识你知道吗？牙膏居然还能这样用！',
    thumbnail: 'https://readdy.ai/api/search-image?query=Various%20household%20items%20arranged%20creatively%20on%20a%20clean%20wooden%20table%2C%20bright%20natural%20lighting%2C%20minimalist%20lifestyle%20photography%2C%20warm%20tones&width=640&height=360&seq=latest-05&orientation=landscape',
    duration: '03:48',
    views: '112.3万',
    category: '生活',
    categorySlug: 'lifestyle',
    author: '冷知识大王',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20knowledge%20content%20creator%20portrait%2C%20smart%20and%20friendly%20look%2C%20clean%20background%2C%20warm%20lighting&width=100&height=100&seq=avatar-13&orientation=squarish',
    date: '2026-08-09',
    description: '牙膏除了刷牙还能干什么？这些生活冷知识保证让你大开眼界。学会这些小技巧，生活方便不止一点点！',
    tags: ['冷知识', '生活技巧', '实用', '牙膏妙用'],
  },
  {
    id: 'v014',
    title: '王者荣耀新英雄深度测评：这伤害数值合理吗？',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20mobile%20game%20character%20showcase%20with%20vibrant%20fantasy%20effects%2C%20dramatic%20colorful%20lighting%2C%20game%20art%20style%2C%20dynamic%20composition&width=640&height=360&seq=latest-06&orientation=landscape',
    duration: '11:20',
    views: '567.2万',
    category: '游戏',
    categorySlug: 'gaming',
    author: '电竞解说老李',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20esports%20commentator%20portrait%2C%20professional%20style%2C%20clean%20background%2C%20warm%20lighting&width=100&height=100&seq=avatar-14&orientation=squarish',
    date: '2026-08-09',
    description: '新英雄上线第一时间深度测评！从技能机制到伤害数值，从出装推荐到连招技巧，全网最全的新英雄攻略就在这里。',
    tags: ['王者荣耀', '新英雄', '游戏测评', '攻略'],
  },
  {
    id: 'v015',
    title: '蔡康永式聊天术：三句话让任何人都想和你做朋友',
    thumbnail: 'https://readdy.ai/api/search-image?query=Two%20people%20having%20a%20warm%20friendly%20conversation%20in%20a%20cozy%20cafe%2C%20soft%20natural%20lighting%2C%20relaxed%20atmosphere%2C%20lifestyle%20photography%20style&width=640&height=360&seq=latest-07&orientation=landscape',
    duration: '08:05',
    views: '345.6万',
    category: '生活',
    categorySlug: 'lifestyle',
    author: '情商研究所',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20psychology%20content%20creator%20portrait%2C%20warm%20and%20wise%20expression%2C%20clean%20background%2C%20soft%20lighting&width=100&height=100&seq=avatar-15&orientation=squarish',
    date: '2026-08-09',
    description: '为什么有的人走到哪里都受欢迎？学会这三句聊天话术，让你在任何社交场合都能游刃有余，轻松成为人群中的焦点。',
    tags: ['社交技巧', '情商', '聊天话术', '人际关系'],
  },
  {
    id: 'v016',
    title: '经典喜剧名场面合集：这些片段看一次笑一次',
    thumbnail: 'https://readdy.ai/api/search-image?query=Funny%20comedy%20scene%20with%20bright%20colorful%20stage%20lighting%2C%20comedic%20expression%2C%20entertainment%20show%20atmosphere%2C%20warm%20theater%20setting&width=640&height=360&seq=latest-08&orientation=landscape',
    duration: '10:12',
    views: '189.4万',
    category: '娱乐',
    categorySlug: 'entertainment',
    author: '笑点制造机',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20content%20creator%20portrait%2C%20funny%20and%20energetic%20expression%2C%20clean%20background%2C%20bright%20lighting&width=100&height=100&seq=avatar-16&orientation=squarish',
    date: '2026-08-08',
    description: '盘点那些经典喜剧电影里的名场面，每一个片段都是喜剧教科书。从周星驰到沈腾，华语喜剧的巅峰时刻都在这里了！',
    tags: ['喜剧', '名场面', '经典电影', '搞笑合集'],
  },
];

export const creators: CreatorItem[] = [
  {
    name: '吃货小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20food%20content%20creator%20portrait%2C%20friendly%20smile%2C%20warm%20kitchen%20lighting%2C%20professional%20headshot&width=200&height=200&seq=creator-01&orientation=squarish',
    followers: '328万',
    videos: 426,
    description: '走遍全国寻味地道美食，用镜头记录舌尖上的中国。',
  },
  {
    name: '萌宠日常',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20pet%20content%20creator%20with%20a%20cute%20cat%2C%20warm%20and%20cozy%20home%20setting%2C%20natural%20lighting&width=200&height=200&seq=creator-02&orientation=squarish',
    followers: '512万',
    videos: 683,
    description: '家里养了三只猫两只狗，每天分享最治愈的萌宠日常。',
  },
  {
    name: '旅途小鹿',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20travel%20vlogger%20portrait%2C%20adventurous%20outdoor%20style%2C%20warm%20sunset%20lighting%2C%20travel%20aesthetic&width=200&height=200&seq=creator-03&orientation=squarish',
    followers: '256万',
    videos: 312,
    description: '背着相机环游世界，用Vlog记录每一段旅途的美好。',
  },
  {
    name: '国风音悦台',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20traditional%20music%20artist%20portrait%2C%20elegant%20hanfu%20style%2C%20traditional%20aesthetic%2C%20soft%20warm%20lighting&width=200&height=200&seq=creator-04&orientation=squarish',
    followers: '189万',
    videos: 256,
    description: '用传统乐器演绎现代音乐，让国风之美被更多人听见。',
  },
  {
    name: '电竞解说老李',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20male%20esports%20host%20portrait%2C%20professional%20gaming%20style%2C%20clean%20background%2C%20studio%20lighting&width=200&height=200&seq=creator-05&orientation=squarish',
    followers: '456万',
    videos: 892,
    description: '专业电竞解说，带你深度了解每一款热门游戏的奥秘。',
  },
  {
    name: '笑点制造机',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20performer%20portrait%2C%20expressive%20and%20funny%20face%2C%20bright%20stage%20lighting%2C%20entertainment%20style&width=200&height=200&seq=creator-06&orientation=squarish',
    followers: '678万',
    videos: 531,
    description: '专注于制造快乐，每一个视频都能让你笑到停不下来。',
  },
];

export const heroSlides = [
  {
    title: '发现精彩，从这里开始',
    subtitle: '海量高清短视频，涵盖娱乐、美食、旅行、音乐等多元内容',
    image: 'https://readdy.ai/api/search-image?query=Modern%20creative%20digital%20content%20creation%20workspace%20with%20warm%20lighting%2C%20abstract%20geometric%20shapes%2C%20soft%20gradient%20background%20in%20warm%20peach%20and%20cream%20tones%2C%20clean%20minimalist%20aesthetic%2C%20technology%20and%20creativity%20fusion&width=1600&height=700&seq=hero-01&orientation=landscape',
    cta: '立即观看',
  },
  {
    title: '优质创作者，等你关注',
    subtitle: '加入密桃视频，发现你最喜爱的内容创作者',
    image: 'https://readdy.ai/api/search-image?query=Warm%20and%20inviting%20creative%20studio%20space%20with%20camera%20equipment%2C%20soft%20natural%20light%2C%20modern%20interior%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20artistic%20atmosphere&width=1600&height=700&seq=hero-02&orientation=landscape',
    cta: '探索创作者',
  },
  {
    title: '随时随地，畅享精彩',
    subtitle: '流畅播放体验，一键分享，发现你的视频新世界',
    image: 'https://readdy.ai/api/search-image?query=Young%20people%20watching%20videos%20on%20mobile%20devices%20in%20a%20cozy%20modern%20cafe%2C%20warm%20atmosphere%2C%20soft%20lighting%2C%20connected%20digital%20lifestyle%2C%20relaxed%20social%20scene&width=1600&height=700&seq=hero-03&orientation=landscape',
    cta: '立即加入',
  },
];